import { BtcChainData } from 'dex-app.cm';

import {
  BTC_LIKE_TOKENS,
  Currency,
  ERC20_TOKENS,
  EVM_NATIVE_TOKENS,
  SOLANA_NATIVE_TOKENS,
  SPL_TOKENS,
} from '@/constants';
import {
  Arb20Currency,
  ArbCurrency,
  Base20Currency,
  BaseCurrency,
  BtcCurrency,
  BtcLikeCurrency,
  CwebCurrency,
  DogeCurrency,
  ERC20Currency,
  EvmCurrency,
  LtcCurrency,
  PolCurrency,
  SolanaCurrency,
  SplCurrency,
  Trc20Currency,
  TronCurrency,
} from '@/types';

export const isEvmNativeCurrency = (currency: Currency): currency is EvmCurrency =>
  (EVM_NATIVE_TOKENS as unknown[]).includes(currency);

export const isErc20Currency = (currency: Currency): currency is ERC20Currency =>
  (ERC20_TOKENS as unknown[]).includes(currency);

export const isCwebCurrency = (currency: Currency): currency is CwebCurrency => currency === Currency.CWEB;

export const isTronCurrency = (currency: Currency): currency is TronCurrency => currency === Currency.TRX;

export const isTrc20Currency = (currency: Currency): currency is Trc20Currency => currency === Currency.USDT_TRX;

export const isBtcCurrency = (currency: Currency): currency is BtcCurrency => currency === Currency.BTC;

export const isLtcCurrency = (currency: Currency): currency is LtcCurrency => currency === Currency.LTC;

export const isPolCurrency = (currency: Currency): currency is PolCurrency => currency === Currency.POL;

export const isDogeCurrency = (currency: Currency): currency is DogeCurrency => currency === Currency.DOGE;

export const isArbCurrency = (currency: Currency): currency is ArbCurrency => currency === Currency.ETH_ARB;

export const isArb20Currency = (currency: Currency): currency is Arb20Currency =>
  ([Currency.USDT_ARB, Currency.USDC_ARB, Currency.ARB] as Currency[]).includes(currency);

export const isBaseCurrency = (currency: Currency): currency is BaseCurrency => currency === Currency.ETH_BASE;

export const isBase20Currency = (currency: Currency): currency is Base20Currency =>
  ([Currency.USDT_BASE, Currency.USDC_BASE] as Currency[]).includes(currency);

export const isBtcLikeCurrency = (currency: Currency): currency is BtcLikeCurrency =>
  (BTC_LIKE_TOKENS as unknown[]).includes(currency);

export const isSolanaCurrency = (currency: Currency): currency is SolanaCurrency =>
  (SOLANA_NATIVE_TOKENS as unknown[]).includes(currency);

export const isSplCurrency = (currency: Currency): currency is SplCurrency =>
  (SPL_TOKENS as unknown[]).includes(currency);

export const isBtcChainData = (data: unknown): data is BtcChainData => {
  if (!data) return false;

  return (
    typeof data === 'object' &&
    'l1TxId' in data &&
    'vout' in data &&
    typeof data.l1TxId === 'string' &&
    typeof data.vout === 'number'
  );
};
